import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Invoice from './components/Invoice';
import About from './components/About';
import Help from './components/Help';
import Login from './components/Login';
import Signup from './components/Signup';
import AdminDashboard from './components/AdminDashboard';
import CookieConsent from './components/CookieConsent';
import Header from './components/sections/Header';
import Footer from './components/sections/Footer';
import { AuthContext } from './context/AuthContext'; 
import ResetPassword from './components/ResetPassword'; // Import the new component
import LandingPage from './components/LandingPage';

import './App.css'; 

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
        <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/about" element={<About />} />
          <Route path="/help" element={<Help />} />
          {/* <Route path="/admin" element={<AdminDashboard />} /> */}
          <Route path="/reset-password" element={<ResetPassword />} />  {/* ✅ Add this line */}


          {/* 🔹 Protected Routes */}
          <Route path="/dashboard" element={<PrivateRoute allowedRoles={['clientA', 'clientB', 'admin']}><Dashboard /></PrivateRoute>} />
          <Route path="/cine" element={<PrivateRoute allowedRoles={['clientA', 'admin']}><Invoice /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute allowedRoles={['admin']}><AdminDashboard /></PrivateRoute>} />
        </Routes>
      </div>
      <CookieConsent />
      <Footer />
    </Router>
  );
}


// 🔹 Updated PrivateRoute Component
function PrivateRoute({ children, allowedRoles }) {
  const { isAuthenticated, userRole } = useContext(AuthContext);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />; // Redirect if not logged in
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/" replace />; // Redirect unauthorized users to Home
  }

  return children;
}

export default App;
